import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';
import Home from './Home';
import Edit from './Edit';
import { Alert, Navbar, Container, Nav, NavItem, Button } from 'reactstrap';
import Login from '../components/Login/Login';
import ForgotPassword from '../components/ForgotPassword/ForgotPassword';
import SvgSpriteLoader from '../components/SvgSpriteLoader';
import { bindActionCreators } from 'redux';
import { getLogin, logout } from '../store/loginActions';
import { closeNotification, getCSRFToken } from '../store/appActions';
import { connect } from 'react-redux';
import './App.css';
import './Themes.css';
import spritesConfig from '../config/sprites';
import { IconLogout } from '../components/Icons/Icons';
import SetPassword from '../components/SetPassword/SetPassword';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }
  componentDidMount() {
    this.props.getCSRFToken();
    if (window.location.pathname !== '/reset-password') {
      this.props.getLogin();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.notification && this.props.notification) {
      setTimeout(() => {
        this.props.closeNotification();
      }, 3500);
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <React.Fragment>
        <SvgSpriteLoader url={spritesConfig.url} />
        <Navbar color="dark" dark expand="md" fixed="top">
          <Container>
            <Link to="/" title="Store Builder Home" className="navbar-brand">
              Store Builder
            </Link>
            {this.props.loggedIn && (
              <Nav>
                <NavItem>
                  <Button
                    color="link"
                    className="text-light"
                    onClick={() => {
                      this.props.logout();
                    }}
                  >
                    <IconLogout /> <span>Log out</span>
                  </Button>
                </NavItem>
              </Nav>
            )}
          </Container>
        </Navbar>
        {this.props.notification && (
          <Alert
            color={this.props.notification.color}
            isOpen={this.props.notification.show}
            toggle={() => this.props.closeNotification()}
            className="modal-alert"
          >
            {this.props.notification.message}
          </Alert>
        )}
        {this.props.loggedIn && (
          <div>
            <Route exact path="/" component={Home} />
            <Route exact path="/edit" component={Edit} />
            <Route exact path="/edit/:storeId/:version" component={Edit} />
          </div>
        )}
        <Route exact path="/login" component={Login} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={SetPassword} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ router, app, login }) => {
  return {
    //Need this so we can use push() in redux actions.
    router,
    notification: app.notification,
    loggedIn: login.loggedIn
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getLogin,
      logout,
      getCSRFToken,
      closeNotification
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js